/*
 * @Author: chenmin
 * @version: 1.0.0
 * @Description: 自定义滚动条
 */
import PerfectScrollbar from './perfect-scrollbar/src'
import './perfect-scrollbar/css/perfect-scrollbar.css'


/**
 * @description 自动判断该更新PerfectScrollbar还是创建它
 * @param {HTMLElement} el - 必填。dom元素
 */
const el_scrollBar = (el) => {
  //在元素上加点私货，名字随便取，确保不会和已有属性重复即可，我取名叫做_ps_
  if (el._ps_ instanceof PerfectScrollbar) {
    el._ps_.update();
  } else {
    let wheelPropagation = !!el.getAttribute('data-wheelPropagation')
    //el上挂一份属性
    el._ps_ = new PerfectScrollbar(el, {
      wheelPropagation: wheelPropagation,
      maxScrollbarLength: 100,
      suppressScrollX: true
    });
  }
};
export default {
  install: (app) => {
    app.directive('scrollbar', {
      //使用inserted钩子函数（初次创建dom）获取使用自定义指令处的dom
      inserted(el, binding, vnode) {
        //判断其样式是否存在position 并且position为"fixed", "absolute"或"relative"
        //如果不符合条件，抛个错误。当然你也可以抛个警告然顺便给其position自动加上"relative"
        //为什么要这么做呢，因为PerfectScrollbar实现原理就是对dom注入两个div，一个是x轴一个是y轴，他们两的position都是absolute。
        //对css稍有常识的人都知道，absolute是相对于所有父节点里设置了position属性的最近的一个节点来定位的，为了能够正确定位，我们要给其设置position属性
        const rules = ["fixed", "absolute", "relative"];
        if (!rules.includes(window.getComputedStyle(el, null).position)) {
          console.error(`perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join("、")}`)
        }
        //el上挂一份属性
        el_scrollBar(el);
        if (!binding.value) {
          return;
        }
        const childElement = el.getElementsByClassName(binding.value)[0];
        if (!childElement) {
          return;
        }
        el._resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            const { height } = entry.contentRect;
            // console.log(`子层div的高度变化为: ${height}px`);
            el_scrollBar(el);
          }
        }).observe(childElement);
      },
      // 指令所在模板被重新解析是调用
      update(el, binding, vnode, oldVnode) {
        try {
          //vnode.context其实就是vue实例，这里其实无需实例也直接用Vue的静态方法
          //故而也可以写成Vue.nextTick
          vnode.context.$nextTick(
            () => {
              el_scrollBar(el);
            }
          )
        } catch (error) {
          el_scrollBar(el);
        }
      },
      // 当指令与元素解绑时...
      unbind(el) {
        // 停止监听
        if (el._resizeObserver) {
          el._resizeObserver.disconnect();
          el._resizeObserver = null;
        }
      }
    });
  },
};


// WEBPACK FOOTER //
// ./src/directive/scrollbar.js